const CircularProgress = {
    init() {
        window.onload = () => {
            const $container = document.querySelector<HTMLElement>('.post-content-section .container');

            if (!$container) {
                return;
            }

            const $svg = $container.querySelector<SVGElement>('.reading-time-animated svg');
            const $progressBar = $container.querySelector<SVGCircleElement>('.reading-time-animated .progress-bar');

            if ($svg && $progressBar) {
                if (window.innerWidth > 992) {
                    const totalLength = $progressBar.getTotalLength();
                    const fixedElement = $container.querySelector('.post-content-section .container .post-single-aside .aside-content') as HTMLElement;

                    setTopValue($svg);

                    $progressBar.style.strokeDasharray = totalLength.toString();
                    $progressBar.style.strokeDashoffset = totalLength.toString();

                    window.addEventListener('scroll', () => {
                        setProgress($container, $progressBar, totalLength, fixedElement);
                    });

                    window.addEventListener('resize', () => {
                        setTopValue($svg);
                    });
                }
            }
        };

        function setTopValue($svg: SVGElement) : void {
            $svg.style.top = (document.documentElement.clientHeight * 0.5) - ($svg.getBoundingClientRect().height * 0.5) + 'px';
        }

        function setProgress($container: HTMLElement, $progressBar: SVGCircleElement, totalLength: number, $fixedElement: HTMLElement) : void {
            const clientHeight = document.documentElement.clientHeight;
            const scrollHeight = $container.scrollHeight;
            const scrollTop = document.documentElement.scrollTop;

            const scrollMiddle = scrollTop + (clientHeight / 2);
            const elmtPosition = $container.offsetTop;
            const elmtEndPosition = elmtPosition + scrollHeight;
            let percentage = (scrollMiddle - elmtPosition) / (elmtEndPosition - elmtPosition);

            if (percentage <= 0) {
                $container.classList.add('completed');
                percentage = 0;
            } else if (percentage >= 1) {
                percentage = 1;
            } else {
                $container.classList.remove('completed');
                percentage = (scrollMiddle - elmtPosition) / (elmtEndPosition - elmtPosition);
            }

            if (scrollMiddle > elmtPosition) {
                if (scrollMiddle > elmtEndPosition) {
                    $fixedElement.classList.add('completed');
                    $fixedElement.classList.remove('sticky');
                } else {
                    $fixedElement.classList.add('sticky');
                    $fixedElement.classList.remove('completed');
                }
            } else {
                $fixedElement.classList.remove('sticky');
            }

            $progressBar.style.strokeDashoffset = (totalLength - (totalLength * percentage)).toString();
        }
    },
};

export default CircularProgress;
